import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { size } from "@clockwise/web-commons/src/styles/type.styles";

export const warning: CSSProperties = {
  fontSize: size.md,
  paddingTop: "10px",
  paddingBottom: "10px",
};
